import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { connect } from 'react-redux'
import { setExportDocumentParam } from '../../redux/actions/exportDocumentActions'
import DatePicker, { registerLocale } from 'react-datepicker'
import { dateFormat } from '../../utils/dateFormat'
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
registerLocale('es', es)

const DateInputField = ({ value, setExportDocumentParam }) => {

  const [date, setDate] = useState()

  const handleChange = dateSelected => {
    dateSelected && setExportDocumentParam({date: dateFormat(dateSelected)})
    setDate(dateSelected)
  }

  useEffect(() => {
    return () => {
      setExportDocumentParam({date: -1})
    }
  }, [])

  return (
    <Form.Group controlId="formBasicEmail">
      <Form.Label>Fecha</Form.Label>
      {/* <Form.Control type="date" onChange={ handleChange }/> */}
      <DatePicker 
        locale = "es"
        selected = {date} 
        onChange = {handleChange}
        dateFormat="dd/MM/yyyy"
        todayButton="Hoy"
        isClearable
        className='form-control'
        placeholderText='Seleccione una fecha'
      />
    </Form.Group>
  )
}

const mapDispatchToProps = {
  setExportDocumentParam
}

export default connect(({ exportDocumentReducer })=>({ value: exportDocumentReducer.date }), mapDispatchToProps)(DateInputField)